import { ContainerType } from "@Base/Engagement/ContainerType";
import { EngagementService } from "@Api/EngagementService";
import { RecommendationBase } from "@Base/Engagement/RecommendationBase";
import { Tenant } from "@Utilities/Tenant";

export class MalachyteRecommendation extends RecommendationBase
{
	private readonly engagementService: EngagementService;

	constructor()
	{
		super();
		this.engagementService = new EngagementService();
	}

	public GetRecommendations = (requests: RecommendationRequest[]): void =>
	{
		if (requests && Array.isArray(requests) && requests.length > 0)
		{
			let exclusions: string[] = [];
			const productsToExclude = document.getElementsByClassName("exclude-product");

			for (var i = 0; i < productsToExclude.length; i++)
			{
				exclusions.push(productsToExclude[i].textContent);
			}

			let containerRequests: ContainerRequest[] = [];	
			const strategyToRequest: { [strategy: string]: RecommendationRequest } = {};
			for (var i = 0; i < requests.length; i++)
			{
				if (requests[i].ResultCount)
				{
					const containerRequest: ContainerRequest = {
						ComponentId: requests[i].ComponentId,
						ExcludedProductIds: exclusions,
						ProductId: requests[i].ProductId,
						ResultCount: requests[i].ResultCount,
						Strategy: requests[i].Strategy
					};
					containerRequests.push(containerRequest);
					strategyToRequest[requests[i].Strategy] = requests[i];
				}
			}

			this.engagementService.GetRecommendations(containerRequests)
				.then((response: string) =>
				{
					if (response && response.length > 0)
					{
						let resultList = [];
						const result = JSON.parse(response);

						if (Array.isArray(result))
						{
							resultList = result;
						}
						else
						{
							resultList.push(result);
						}

						const recommendationList = this.HydrateRecommendations(resultList);

						for (var i = 0; i < resultList.length; i++)
						{
							const recommendations = recommendationList[resultList[i].strategy_name];

							if (!recommendations)
							{
								continue;
							}

							const originalRequest = strategyToRequest[resultList[i].strategy_name];

							let title: string = "";
							let containerType: string = "";
							let divName: string = "";

							if (originalRequest)
							{
								title = originalRequest.TitleOverride
									? originalRequest.TitleOverride
									: this.KebabToTitleCase(resultList[i].strategy_name);

								containerType = originalRequest.ContainerType;
								divName = originalRequest.DivName;
							}

							switch (Tenant.Type)
							{
								case "HC":
								case "HW":
									if (containerType === ContainerType.HCProductCard)
									{
										this.RenderHCProductCard(divName, title, recommendations);
									}
									else if (containerType === ContainerType.HCHoverRecs)
									{
										this.RenderHCHoverRecs(divName, title, recommendations);
									}
									break;
								case "Fun":
									if (containerType === ContainerType.FunProductCard)
									{
										this.RenderFunProductCard(divName, title, recommendations);
									}
									else if (containerType === ContainerType.RecentlyViewedSide)
									{
										this.RenderRecentlyViewedSide(divName, recommendations);
									}
									break;
								default:
									break;
							}

							//this.TrackRecommendationShown(title, recommendations);
						}
					};
				})
				.catch((error) =>
				{
					console.log(error);
				});
		}
	};

	private KebabToTitleCase = (str: string): string =>
	{
		return str
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
	};
}

export interface RecommendationRequest
{
	ComponentId: string,
	ContainerType: string,
	DivName: string,
	ProductId: string,
	ResultCount: number,
	TitleOverride?: string,
	Strategy: string
}
export interface ContainerRequest
{
	ComponentId: string,
	ExcludedProductIds: string[],
	ProductId: string,
	ResultCount: number,
	Strategy: string
}